import { render, staticRenderFns } from "./ReviewReplied.vue?vue&type=template&id=e09df4ac"
import script from "./ReviewReplied.vue?vue&type=script&lang=js"
export * from "./ReviewReplied.vue?vue&type=script&lang=js"
import style0 from "./ReviewReplied.vue?vue&type=style&index=0&id=e09df4ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports